<template>
    <div class="page-container">
        <main class="main magazine search-wrap">
            <template v-if="loading">
                <span class="header-msg text-bold text-extended">loading...</span>
            </template>
            <template v-if="noResults && !loading">
                <div class="no-results-wrap">
                    <span class="header-msg text-bold text-extended">There appear to be no results from your search.</span>
                    <router-link class="bth text-bold text-extended" to="/">Back to Home</router-link>
                </div>
            </template>
            <template v-if="content.length && !loading">
                <section id="magazine">
                    <div class="section-wrap magazine-wrap">
                        <span class="header-msg text-bold text-extended">Search Results For {{ $route.params.searchTerm }}</span>
                        <div class="grid-container c3 list-articles">
	                        <ArticleItem v-for="(item) in content" :key="item.id" :article="item">
				            </ArticleItem>
                        </div>
                    </div>
                </section>
            </template>
        </main>
    </div>
</template>

<script>
import ArticleItem from '../components/ArticleItem.vue';

export default {

    components: {
        ArticleItem
    },

    data () {
        return {
            loading: false,
            content: [],
            noResults: false
        }
    },

    watch: {
        '$route' (to, from) {
            if (to.path !== to.from) {
                this.content = [];
                this.noResults = false;
                this.getContent();
            }
        }
    },


    created () {

        
        this.getContent();
    },


    methods: {

        async getContent () {
            

            if (this.$store.state.navOpen) {
                this.$store.commit('TOGGLE_NAV');
            }

            this.loading = true;

            for (let route of this.$router.options.routes) {
                if (route.path.slice(1) === this.$route.params.searchTerm.toLowerCase()) {
                    this.loading = false;
                    this.$router.push(`/${this.$route.params.searchTerm.toLowerCase()}`)
                    return;
                }
            }

            try {
                
                const articles = await this.$prismic.client.query([
                    this.$prismic.Predicates.at('document.type', 'article'),
                    this.$prismic.Predicates.fulltext('document', this.$route.params.searchTerm)
                ]);

                const newsPosts = await this.$prismic.client.query([
                    this.$prismic.Predicates.at('document.type', 'post'),
                    this.$prismic.Predicates.fulltext('document', this.$route.params.searchTerm)
                ]);

                console.log(articles.results, newsPosts.results)

                if (articles.results.length === 0 && newsPosts.results.length === 0) {
                    this.noResults = true;
                } else {
                    this.content = [...articles.results, ...newsPosts.results];
                }

               
                this.loading = false;
                
    
        
            } catch (error) {
                console.log(error)
            }
        }

    }
}
</script>

<style scoped>

    

    .no-results-wrap {
        padding: 1rem;
        text-transform: uppercase;
        font-size: 1.2rem;
    }

    .search-wrap .header-msg {
        padding: 1rem;
        text-transform: uppercase;
        display: block;
    }

    .bth {
        padding: 1rem;
    }

    /* @media screen and (max-width: 768px) {
        .header-msg {
            
        }
    } */

</style>